<!-- @format -->

@if (learningMaterial || literature?.length > 0) {
  <div class="row">
    <div class="col-md-12">
      <sis-description-list>
        <dl>
          <!-- This dl element is just to trick SonarQube, it won't actually end up in the final HTML at all -->
          @if (learningMaterial) {
            <ng-template #listItem>
              <dt class="label">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.LEARNING_MATERIAL" | translate }}</dt>
              <dd class="value">
                <sis-localized-markup-string-view [content]="learningMaterial"></sis-localized-markup-string-view>
              </dd>
            </ng-template>
          }
          @if (literature?.length > 0) {
            <ng-template #listItem>
              <dt class="label">{{ "STUDIES.COURSE_UNITS_DESCRIPTION.LITERATURE" | translate }}</dt>
              <dd class="value">
                <ul>
                  @for (item of literature; track item) {
                    <li>
                      @if (item.type === "LiteratureName") {
                        <span>{{ item.name }}</span>
                      }
                      @if (item.type === "LiteratureReference") {
                        <span>
                          <a fudisLink [title]="item.url" [external]="true" [href]="item.url"></a>
                        </span>
                      }
                    </li>
                  }
                </ul>
              </dd>
            </ng-template>
          }
        </dl>
      </sis-description-list>
    </div>
  </div>
} @else {
  <div>
    <span>{{ "SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN" | translate }}</span>
  </div>
}
